export enum WelcomeSplashVariant {
  SHOW = 'show',
  SKIP = 'skip'
}
